import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout, { PageHeader, Surface, StatusPill } from "@/components/Layout";
import { api } from "@/lib/api";

export default function UsersPage() {
  const [items, setItems] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [merchantFilter, setMerchantFilter] = useState("");

  useEffect(() => { api.get("/admin/merchants").then((r) => setMerchants(r.data.items)); }, []);
  useEffect(() => {
    const q = merchantFilter ? `?merchant_id=${merchantFilter}` : "";
    api.get(`/admin/users${q}`).then((r) => setItems(r.data.items));
  }, [merchantFilter]);

  const byId = Object.fromEntries(merchants.map(m => [m.id, m.company_name]));

  return (
    <Layout>
      <div className="p-6 lg:p-10" data-testid="users-page">
        <PageHeader title="Cardholders" subtitle="End-users created by merchants under their KYC programme." />

        <Surface className="p-3 mb-4 flex items-center gap-3">
          <span className="text-[10px] uppercase tracking-[0.05em] font-semibold text-zinc-500">Merchant</span>
          <select
            data-testid="users-merchant-filter"
            value={merchantFilter}
            onChange={(e) => setMerchantFilter(e.target.value)}
            className="h-8 text-xs px-2 border border-zinc-200 rounded-sm bg-white focus:ring-1 focus:ring-zinc-900 focus:border-zinc-900 outline-none"
          >
            <option value="">All</option>
            {merchants.map(m => <option key={m.id} value={m.id}>{m.company_name}</option>)}
          </select>
          <div className="ml-auto text-xs text-zinc-500">{items.length} users</div>
        </Surface>

        <Surface className="overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-[0.05em] font-semibold text-zinc-500 border-b border-zinc-100">
                <th className="px-5 py-3">Name</th>
                <th className="px-5 py-3">Email</th>
                <th className="px-5 py-3">Phone</th>
                <th className="px-5 py-3">Merchant</th>
                <th className="px-5 py-3">KYC</th>
                <th className="px-5 py-3">Created</th>
              </tr>
            </thead>
            <tbody>
              {items.map((u) => (
                <tr key={u.id} className="border-b border-zinc-50">
                  <td className="px-5 py-3 font-medium">{u.first_name} {u.last_name}</td>
                  <td className="px-5 py-3 text-xs">{u.email}</td>
                  <td className="px-5 py-3 text-xs">{u.phone || "—"}</td>
                  <td className="px-5 py-3 text-xs">{byId[u.merchant_id] || u.merchant_id.slice(0, 8)}</td>
                  <td className="px-5 py-3">
                    <Link to={`/users/${u.id}/kyc`} className="inline-flex items-center gap-2 hover:underline">
                      <StatusPill value={u.kyc_status} />
                    </Link>
                  </td>
                  <td className="px-5 py-3 text-xs text-zinc-500">{(u.created_at || "").slice(0, 10)}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={6} className="px-5 py-10 text-center text-xs text-zinc-500">No cardholders yet.</td></tr>
              )}
            </tbody>
          </table>
        </Surface>
      </div>
    </Layout>
  );
}
